/**
 * A 70×26 trend line (EP00-S10, moved into the chart kit by EP13-S04).
 *
 * Decorative, and `aria-hidden` for that reason: the number beside it is the
 * information, and "line chart" announced after every tile is noise. Plain SVG,
 * not Recharts, because the KPI tile renders on the eager home dashboard and
 * the chart library belongs in the lazy analytics chunk.
 *
 * `vector-effect: non-scaling-stroke` keeps the line one pixel wide however the
 * viewBox is stretched. Mirrored in Arabic, where time runs right to left.
 */
export function Sparkline({ points }: { points: number[] }) {
	const width = 70;
	const height = 26;
	const low = Math.min(...points);
	const high = Math.max(...points);
	// A flat series has no range to scale against; 1 keeps the division safe and
	// draws it down the middle, which is what flat looks like.
	const span = high - low || 1;

	const path = points
		.map((point, index) => {
			const x = (index / (points.length - 1)) * width;
			const y = height - ((point - low) / span) * height;
			return `${x.toFixed(1)},${y.toFixed(1)}`;
		})
		.join(" ");

	return (
		<svg
			aria-hidden="true"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			className="shrink-0 overflow-visible rtl:-scale-x-100"
		>
			<polyline
				points={path}
				fill="none"
				stroke="var(--viz-cat-1)"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
				vectorEffect="non-scaling-stroke"
			/>
		</svg>
	);
}
